<template>
  <ListFilterForm
    :is-filter-enabled="props.isFilterEnabled"
    :initial-filter="initialFilter"
    @toggle-filter="emits('toggleFilter')"
    @set-filter="setParentFilter"
  >
    <template #fields="slotProps">
      <div class="flex flex-col">
        <label for="segmentMame" class="small-label">Название магазина</label>
        <InputText
          id="segmentMame"
          placeholder="Введите название"
          v-model="slotProps.filter.name"
          aria-describedby="username-help"
        />
      </div>

      <div class="flex flex-col m-t-8">
        <label class="small-label">Короткое название</label>
        <InputText
          placeholder="Введите значение"
          v-model="slotProps.filter.short_name"
          aria-describedby="username-help"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label class="small-label">ИНН</label>
        <InputText
          placeholder="Введите значение"
          v-model="slotProps.filter.inn"
          aria-describedby="username-help"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label class="small-label">Хэш ИНН</label>
        <InputText
          placeholder="Введите значение"
          v-model="slotProps.filter.hash_inn"
          aria-describedby="username-help"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label class="small-label">Данные от провайдеров</label>
        <div class="fl m-b-8 m-t-4">
          <RadioButton
            v-model="slotProps.filter.has_data_from_providers"
            inputId="shop_has_data_from_providers_yes"
            name="shop_has_data_from_providers"
            value="1"
          />
          <label for="shop_has_data_from_providers_yes" class="p-l-4">Да</label>
        </div>
        <div class="fl">
          <RadioButton
            v-model="slotProps.filter.has_data_from_providers"
            inputId="shop_has_data_from_providers_no"
            name="shop_has_data_from_providers"
            value="0"
          />
          <label for="shop_has_data_from_providers_no" class="p-l-4">Нет</label>
        </div>
      </div>
      <div class="flex flex-col m-t-8 category-filter-wrapper">
        <label for="state" class="small-label">Категория</label>
        <MultiSelect
          v-model="slotProps.filter.category"
          optionValue="id"
          :options="catsList"
          optionLabel="name"
          placeholder="Выберите значение"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Автор</label>
        <CatalogDataBaseInput
          :useIdOnly="true"
          selectType="user"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.user"
          @update:modelValue="($event) => (slotProps.filter.user = $event)"
        ></CatalogDataBaseInput>
      </div>
      <div class="flex flex-col m-t-8">
        <label for="date" class="small-label">Дата создания</label>
        <Calendar
          id="date"
          panelClass="not-extended"
          placeholder="Выберите значение"
          v-model="slotProps.filter.cdate"
          aria-describedby="date-help"
          showIcon
          iconDisplay="input"
          inputId="icondisplay"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label for="date" class="small-label">Дата редактирования</label>
        <Calendar
          id="date"
          panelClass="not-extended"
          placeholder="Выберите значение"
          v-model="slotProps.filter.mdate"
          aria-describedby="date-help"
          showIcon
          iconDisplay="input"
          inputId="icondisplay"
        />
      </div>
    </template>
  </ListFilterForm>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import InputText from "primevue/inputtext";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";
import Calendar from "primevue/calendar";
import MultiSelect from "primevue/multiselect";
import RadioButton from "primevue/radiobutton";

import { useCategoriesStore } from "@/store/catalog_data/categories";

const categoriesStore = useCategoriesStore();
const catsList = ref([]);

onMounted(() => {
  categoriesStore.getC1Categories().then((cats) => {
    catsList.value = cats;
  });
});

const props = defineProps<{
  isFilterEnabled: boolean;
}>();
const emits = defineEmits(["toggleFilter", "setFilter"]);

const initialFilter = {
  name: "",
  short_name: "",
  inn: "",
  hash_inn: "",
  cdate: null,
  mdate: null,
  user: [] as number[],
  category: [] as number[],
  has_data_from_providers: "",
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};
</script>
